/**
 * Central definition of the Amwins InstantQuote Help Center (Intercom) links.
 *
 * IMPORTANT: none of these links may carry the `intercom_button` class, and they
 * must not be nested inside an element that has it. `main.ts` registers
 * `custom_launcher_selector: '.intercom_button'`, so any click inside such an
 * element opens the Intercom messenger panel. Help Center links must only open
 * a new browser tab.
 *
 * All links are rendered as plain anchors with target="_blank" so the portal tab
 * keeps its route, scroll position and in-progress form state.
 */

export const HELP_CENTER_HOME = 'https://intercom.help/amwins/en/';

export const HELP_CENTER_NEWS = 'https://intercom.help/amwins/en/collections/19665775-news-archive';

export const HELP_CENTER_DOCUMENTS = 'https://intercom.help/amwins/en/collections/19665774-document-center';

// Guidance on completing state packets, linked from the bind page diligent-effort
// step. Intentionally the same URL for every state.
export const HELP_CENTER_STATE_PACKETS = 'https://intercom.help/amwins/en/articles/15520886-diligent-effort';
